import store from '@/store'

export default [
  {
    path: '/score-assessments',
    name: 'score-assessment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/score-assessment/index-v2.vue')
  },
  {
    path: '/score-assessments/:id',
    name: 'score-assessment-create',
    meta: { requiresAuth: true },
    props: route => ({
      id: route.params.id,
      program_structure_id: route.query.program_structure_id
    }),
    component: () => import('@/pages/score-assessment/create.vue')
  }
]
